import { 
  FaFile, 
  FaQuestionCircle, 
  FaCog, 
  FaComments,
  FaPlay,
  FaHome,
  FaChartBar
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

function SideBarItems({ isLarge }) {
  const location = useLocation();
  const sideItems = [
    {
      submenus: [
        {
          icon: <FaChartBar className="w-5 h-5" />,
          title: "Dashboard",
          url: "/admin",
        },
        {
          icon: <FaFile className="w-5 h-5" />,
          title: "Documents",
          url: "/admin/docs",
        },
        {
          icon: <FaQuestionCircle className="w-5 h-5" />,
          title: "Questions",
          url: "/admin/questions",
        },
        {
          icon: <FaPlay className="w-5 h-5" />,
          title: "Lessons",
          url: "/admin/lessons",
        },
        {
          icon: <FaComments className="w-5 h-5" />,
          title: "Chat History",
          url: "/admin/chat-history",
        },
        {
          icon: <FaCog className="w-5 h-5" />,
          title: "Settings",
          url: "/admin/settings",
        },
      ],
    },
  ];

  return (
    <div className="space-y-2">
      {sideItems?.map((elm, ind) => {
        return (
          <div key={ind}>
            <div className={`text-xs font-semibold text-blue-200 uppercase tracking-wider mb-3 transition-all duration-300 ${!isLarge && "opacity-0 hidden"}`}>
              Content Management
            </div>
            <div className="space-y-1">
              {elm.submenus.map((item, i) => {
                const isActive = location.pathname === item.url;
                return (
                  <Link key={i} to={item.url}>
                    <div
                      className={`flex items-center space-x-3 px-3 py-2 rounded-lg transition-all duration-200 group ${
                        isActive 
                          ? 'bg-white/20 text-white shadow-lg' 
                          : 'text-blue-200 hover:bg-white/10 hover:text-white'
                      }`}
                    >
                      <span className="flex items-center justify-center w-5 h-5">
                        {item.icon}
                      </span>
                      {isLarge && (
                        <span className="text-sm font-medium transition-all duration-300">
                          {item.title}
                        </span>
                      )}
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SideBarItems;
